import 'what-input';

import PropTypes from 'prop-types';
import React from 'react';

import { setLocation } from '$utilities/location';
import { setUserAgent } from '$utilities/user-agent';
import { SkipLink } from '$partials/ui';
import * as Pages from '$pages';
import { GridLines } from '$partials/global/index';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @component App
 * @props (see propTypes)
 *
 * Renders the application.
 * 1. If the page component requested doesn’t exist, escapes the function.
 * 2. Skip link are useful for keyboard users to access the main content of the page
 *    straight away without the hassle of navigating through the navigation at each page load.
 * 3. Page component (HomePage, UnionPage, etc.).
 */
const App = (props) => {
    if (props.location) {
        setLocation(props.location);
    }

    if (props.userAgent) {
        setUserAgent(props.userAgent);
    }

    /* [1] */
    if (!props.pageComponent || typeof (Pages[props.pageComponent]) === 'undefined') {
        return null;
    }

    const Component = Pages[props.pageComponent];

    return (
        <>
            <SkipLink href='#main-content'>Skip to main content</SkipLink> {/* [3] */}
            <SkipLink href='#primary-navigation'>Skip to primary navigation</SkipLink> {/* [3] */}

            {(props?.data?.page?.backgroundColour && props?.data?.page?.foregroundColour) &&
                <style dangerouslySetInnerHTML={{__html: `
                    :root {
                        --background: ${props?.data?.page?.backgroundColour};
                        --foreground: ${props?.data?.page?.foregroundColour};
                    }
                `}} />
            }

            <Component {...props} /> {/* [3] */}

            {props.dev && (<GridLines />)}
        </>
    );
};

/* ========================================================================= */
/* Typing & export(s) */
/* ========================================================================= */

App.propTypes = {
    data: PropTypes.shape({
        page: PropTypes.shape({
            backgroundColour: PropTypes.string.isRequired,
            foregroundColour: PropTypes.string.isRequired,
        }),
    }),
    dev: PropTypes.bool,
    location: PropTypes.string,
    pageComponent: PropTypes.string.isRequired,
    timezone: PropTypes.string,
    userAgent: PropTypes.object.isRequired
};

export { App };

export default App;
